/* The patient portal (docs/plans/phase3-portal-feedback-kiswahili.md §7.1): phone first, one
   column on the soft blue-grey surface, white cards, the same tokens as the staff app. Works
   at 360px wide with 44px touch targets; on wide screens the column stays readable. */
.page {
  min-height: 100vh;
  background: var(--canvas);
  color: var(--ink);
}

.header {
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid var(--border);
  background: var(--paper);
}

.headerInner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  max-width: 720px;
  margin: 0 auto;
  padding: var(--space-3) var(--space-4);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
  font: var(--t-heading);
  font-weight: 600;
}

.brand::before {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-control);
  background: var(--brand);
  color: var(--on-brand);
  font-weight: 600;
  content: 'W' / '';
}

.brandName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headerActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.main {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  max-width: 720px;
  margin: 0 auto;
  padding: var(--space-5) var(--space-4) var(--space-7);
}

.title {
  font: var(--t-display);
}

.lead {
  color: var(--graphite);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5);
  border: var(--card-border);
  border-radius: var(--radius-card);
  background: var(--paper);
  box-shadow: var(--shadow-card);
}

.cardTitle {
  font: var(--t-heading);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-3);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--rule);
  border-radius: var(--radius-control);
}

.itemHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2);
  font-weight: 600;
}

.meta {
  color: var(--graphite);
}

.identifier {
  font-family: var(--font-id);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.line {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
}

.amount {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.cancelled {
  color: var(--graphite);
  text-decoration: line-through;
}

.totals {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--space-1) var(--space-3);
  margin: 0;
  padding-top: var(--space-2);
  border-top: 1px solid var(--rule);
}

.totals dt {
  color: var(--graphite);
}

.totals dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.results {
  width: 100%;
  border-collapse: collapse;
}

.results th,
.results td {
  padding: var(--space-2) var(--space-2) var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
  text-align: left;
  vertical-align: top;
}

.results th {
  color: var(--graphite);
  font-weight: 500;
}

.results td.value {
  font-variant-numeric: tabular-nums;
}

.flag {
  font-weight: 600;
}

/* Allergies: the clinical danger panel, the one place the portal uses danger red. */
.allergyList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: var(--space-4);
  border: 1px solid var(--danger);
  border-radius: var(--radius-control);
  background: var(--danger-tint);
  list-style: none;
}

.allergyName {
  color: var(--danger);
  font-weight: 600;
}

.people {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.empty {
  color: var(--graphite);
}

@media (width < 640px) {
  .card {
    padding: var(--space-4);
  }
}
